export const NUMBERS = {
    DECIMAL_PRECISION: {
        DEFAULT: 2,
        DISCOUNT: 2,
        PRODUCT_PRICE: 4,
        SUBTOTAL: 4,
        FREIGHT_PRICE: 2,
        CHARGES_PRICE: 2,
        TRIBUTES_PRICE: 2,
        ORDER_PRICE: 2,
        DISCOUNT_PERCENTAGE: 2,
        PRODUCT_QUANTITY: 3,
        PRODUCT_WEIGHT: 3,
    },
}
